// @core/api/endpoints/team/update_team_user_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateTeamUserRoleRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Update user role assignment
 * Updates the complete set of roles assigned to a user within the team. Replaces all existing role assignments.
 */
export async function UpdateTeamUserRole(
  team_id: string,
  user_id: string,
  data: UpdateTeamUserRoleRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/users/:user_id/roles`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
